export enum UpgradeStatus {
  Idle = 'idle',

  // A downloaded update means the new image has been downloaded to the memory but is not yet set as active and the migration has not been done
  Downloaded = 'downloaded',

  // A pending update means the new image has been downloaded to the memory, is set as active and the migration has been done
  Pending = 'pending',

  // An ephemeral update means we are running the new image and we have to commit the change
  Ephemeral = 'ephemeral',
}
